export default __webpack_public_path__ + "static/media/step_tick.0418eea7.svg";